import { createSelector } from 'reselect';
import { selectMapAttribution, selectMapAttributionKey, } from '../components/mapattribution/selectors';
export const getComponets = createSelector([
    (state) => state.page.pageTemplates,
    (state) => state.config.components,
    (state) => state.page.hiddenPreviewComponents,
    selectMapAttributionKey,
    selectMapAttribution,
], (pageTemplates = [], configComponents, hiddenPreviewComponents = [], mapAttributionKey, mapAttribution) => {
    const parsedAllAreas = {};
    const editableComponents = {};
    const otherComponents = {};
    const pageAreas = Array.apply(null, Array(pageTemplates.length));
    pageTemplates.forEach((pageTemp, num) => {
        const parsedAreas = parseAreas(pageTemp.areas);
        for (const compKey in parsedAreas) {
            if (!configComponents[compKey])
                continue;
            if (!parsedAllAreas[compKey]) {
                parsedAllAreas[compKey] = {
                    ...configComponents[compKey],
                    areas: [...pageAreas],
                    isPreviewHidden: hiddenPreviewComponents.indexOf(compKey) > -1 ||
                        !!(compKey === mapAttributionKey && mapAttribution?.showOverMap),
                    editable: !!configComponents[compKey].editable,
                };
            }
            parsedAllAreas[compKey].areas[num] = parsedAreas[compKey];
        }
    });
    // setrideni dle konfigurace a zda jsou editovatelene
    for (const compKey in configComponents) {
        if (!parsedAllAreas.hasOwnProperty(compKey))
            continue;
        configComponents[compKey].editable
            ? (editableComponents[compKey] = parsedAllAreas[compKey])
            : (otherComponents[compKey] = parsedAllAreas[compKey]);
    }
    return { ...editableComponents, ...otherComponents };
});
export const parseAreas = (areas) => {
    const result = {};
    let row = 1;
    areas.replace(/"([^"]+)"/g, (_, comps) => {
        comps.split(/[ ]+/).forEach((comp, col) => {
            !result[comp] && (result[comp] = [row, col + 1, null, null]);
            result[comp][2] = row + 1;
            result[comp][3] = col + 2;
        });
        row++;
    });
    return result;
};
//# sourceMappingURL=selectors.js.map